import { render } from "./VenueView.vue?vue&type=template&id=c59e4f50"
import script from "./VenueView.vue?vue&type=script&lang=js"
export * from "./VenueView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__